import { Link } from 'react-router-dom';
import { ClipboardList } from 'lucide-react';
import { PanelCard, Track, EmptyState } from '../../../components/ui';
import type { AcademicDashboardResponse } from '../../../api/types';
import { compactGrade } from './format';

export default function WeakChaptersCard({ d, className = '' }: { d: AcademicDashboardResponse; className?: string }) {
  return (
    <PanelCard className={className} title="Weakest chapters" actions={<span className="text-[13px] text-muted">% correct</span>}>
      {d.weak_chapters.length === 0 ? <EmptyState compact icon={<ClipboardList size={22} />} title="Not enough chapter data yet" /> : (
        <ul>
          {d.weak_chapters.map((c) => (
            <li key={c.chapter_id} className="flex items-center gap-3 border-b border-hairline py-[11px] last:border-0">
              <span className="min-w-0 flex-1">
                <span className="block truncate font-semibold">{c.name}</span>
                <span className="text-xs text-muted">
                  {c.grade_names && c.grade_names.length > 0
                    ? [c.subject_name ?? '—', c.grade_names.map(compactGrade).join(', ')].join(' · ')
                    : `${c.subject_name ?? '—'} · ${c.students_below_pass} of ${c.students} below pass`}
                </span>
              </span>
              <Track value={c.class_avg} tone="accent" className="w-[70px] flex-none" label={`${c.name} correct`} />
              <span className="w-[38px] text-right font-mono font-semibold">{Math.round(c.class_avg)}%</span>
            </li>
          ))}
        </ul>
      )}
      <Link to="/class-performance#cycles" className="mt-3.5 flex min-h-[44px] items-center justify-center rounded-[12px] bg-navy px-4 text-sm font-semibold text-white no-underline hover:bg-navy-2 hover:text-white">
        Start a remediation cycle
      </Link>
    </PanelCard>
  );
}
